import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { USER_NAV_ACTIONS } from 'src/app/extensions/constants/commonConstants';
import { GlobalService } from 'src/app/extensions/services/global.service';
@Component({
  selector: 'sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
  standalone: false,
})
export class SidebarMenuComponent implements OnInit {
  @Input() menuItems: app.models.SidebarMenuItems[] = [];
  @Input() isAdmin: boolean;
  @Input() username: string;
  @Input() showAppVersion: boolean;
  @Output() userNavOptionSelect = new EventEmitter<string>();

  @ViewChild('accordionItem') public accordionItem: NgbAccordionItem;

  expanded: boolean = false;

  USER_NAV_ACTIONS = USER_NAV_ACTIONS;

  public constructor(
    private _globalService: GlobalService,
    private _router: Router
  ) {}

  public ngOnInit(): void {
    this.expanded = this._globalService.isDrawerExpanded;
  }

  redirectMenu(route: string) {
    if (!route) {
      this._router.navigate(['']);
      return;
    }
    this._router.navigate([route]);
  }

  drawerToggle(drawer: any) {
    this._globalService.isDrawerExpanded = !drawer.expanded;
    if (drawer.expanded && this.accordionItem) {
      this.accordionItem.collapse();
    }
    drawer.toggle();
  }

  expandHandler(drawer: any) {
    if (!drawer.expanded) {
      this.drawerToggle(drawer);
    }
  }

  onUserNavOptionSelect(option: string) {
    this.userNavOptionSelect.emit(option);
  }
}
